import siteSetupNames from './site-setup-names';

export default {
  [siteSetupNames.CATEGORY]: 1,
  [siteSetupNames.SITE_NAME]: 3,
  [siteSetupNames.BUSINESS_NAME]: 4,
  [siteSetupNames.BUSINESS_DETAILS]: 5,
  [siteSetupNames.HOW_TO_BUILD]: 2,
  [siteSetupNames.GALLERY]: 2,
};
